import React from 'react'

const LEGACY_PROVIDERS = [
    'sdlets',
    'sdllanguagecloudtranslation',
]

export const LegacyInfo = ({ providerId }) => {
    if (!LEGACY_PROVIDERS.includes(providerId)) {
        return null
    }

    return (
        <div className="doc__legacy-provider-wrapper">
            <div className="doc__legacy-provider">
                This is a legacy product that may no longer be available from its vendor.
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/LegacyInfo.jsx